import React, {useCallback, useEffect, useRef, useState} from "react";
import {getDataGroupByMonth} from "../../../services/Trading";
import {Alert} from "@material-ui/core";
import messageTypes from "../../../constants/MessagesTypes";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {getDataPerformanceMonthFundamental} from "../../../services/FundamentalTrading";
import {Form} from "@unform/web";
import InputSelect from "../../Form/InputSelect";
import InputDate from "../../Form/InputDate";
import CustomButton from "../../Form/Button";
import {AiOutlineSearch} from "react-icons/ai";
import * as Yup from "yup";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import {FormWrapper} from "../../../styles/listPageTheme";
import {
    PerformanceFilterSection,
    PerformanceFilterTitle,
    PerformanceFilterRow,
    PerformanceFilterField,
    PerformanceFilterActions,
    performancePrimaryButtonStyle,
    PerformanceChartHeading,
    PerformanceChartWrap,
    performanceHighchartsDark,
} from "../../../pages/Report/Performance/styles";

export default function TradingPerformanceMonth({...props}) {
    const [isData, setData] = useState(null);
    const [options, setOptions] = useState([]);
    const [resultAnalysis, setResultAnalysis] = useState(null);
    const formRef = useRef(null);
    const { t } = useTranslation();

    const [filter, setFilter] = useState({
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        typeAnalysis: 'TECHNICAL',
    });

    async function handleSubmit(data) {
        try {

            formRef.current.setErrors({});
            const schema = Yup.object().shape({
                year: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });


            setFilter({
                year: data.year,
                typeAnalysis: data.typeAnalysis || 'TECHNICAL',
            });

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    useEffect( () => {
        if (filter.typeAnalysis === 'FUNDAMENTAL') {
            getDataPerformanceMonthFundamental({
                year: filter.year,
            }).then((data) => {
                if (!data || data === '' || !data.data) {
                    setData(false);
                    return;
                }

                setData(true);

                var result = [];
                for (var key in data.data.data) {
                    var item = data.data.data[key];

                    const qtdeWin = item.data[0] ? parseInt(item.data[0]['qtdeWin']) : 0;
                    const qtdeLoss = item.data[0] ? parseInt(item.data[0]['qtdeLoss']) : 0;

                    if (qtdeWin || qtdeLoss) {
                        const percent = (qtdeLoss + qtdeWin) ? qtdeWin * 100 / (qtdeLoss + qtdeWin) : null;
                        result.push(percent);
                    }
                }

                setResultAnalysis(result);
            });

        } else {
            getDataGroupByMonth({
                year: filter.year,
            }).then((data) => {
                if (!data || data === '' || !data.data) {
                    setData(false);
                    return;
                }

                setData(true);
                var result = [];
                for (var key in data.data.data) {
                    var item = data.data.data[key];

                    const qtdeWin = parseInt(item['qtdeWin']);
                    const qtdeLoss = parseInt(item['qtdeLoss']);
                    const qtdeDraw = parseInt(item['qtdeDraw']);


                    if (qtdeWin || qtdeLoss || qtdeDraw) {
                        const percent = (qtdeLoss + qtdeWin + qtdeDraw) ? qtdeWin * 100 / (qtdeLoss + qtdeWin + qtdeDraw) : null;
                        result.push([item.month, percent]);
                    }
                }

                setResultAnalysis(result);
            });
        }
    }, [filter]);

    const updateChart = useCallback(() => {
        setOptions({
            title: {
                text: ''
            },
            subtitle: {
                text: ``
            },
            chart: {
                ...performanceHighchartsDark.chart,
                type: 'areaspline',
            },
            credits: performanceHighchartsDark.credits,
            legend: performanceHighchartsDark.legend,
            xAxis: {
                ...performanceHighchartsDark.xAxisBase,
                crosshair: false,
            },
            series: [
                {
                    name: filter.typeAnalysis === 'FUNDAMENTAL' ? t('performance_graphic_month_name_series_fundamental_analysis') : t('performance_graphic_month_name_series_technical_analysis'),
                    data: resultAnalysis,
                    color: '#1cc88a',
                }
            ],
            yAxis: {
                min: 0,
                ...performanceHighchartsDark.yAxisBase,
                title: {
                    ...performanceHighchartsDark.yAxisBase.title,
                    text: t('performance_graphic_month_title_yaxy'),
                },
            },
            tooltip: {
                headerFormat: `<span style="font-size:10px">${t("month")} {point.key}</span><table>`,
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                series: {
                    fillColor: {
                        linearGradient: [0, 0, 0, 400],
                        stops: [
                            [0, '#1cc88a'],
                            [
                                1,
                                Highcharts.color(Highcharts.getOptions().colors[0])
                                    .setOpacity(0)
                                    .get("rgba"),
                            ],
                        ],
                    },
                },
            },
        });
    }, [resultAnalysis, setOptions, filter]);

    useEffect(updateChart, [resultAnalysis]);

    const buttonHoverIn = (e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.45)';
    };
    const buttonHoverOut = (e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = performancePrimaryButtonStyle.boxShadow;
    };

    const showTypeAnalysis = [
        'teste@teste.com',
    ].includes(localStorage.getItem('userKey'));

    return (
        <div {...props}>
            <PerformanceFilterSection>
                <Form ref={formRef} onSubmit={handleSubmit}>
                    <PerformanceFilterTitle>
                        <i className="fas fa-funnel-dollar" aria-hidden="true"/>
                        {t('filter')}
                    </PerformanceFilterTitle>
                    <FormWrapper>
                        <PerformanceFilterRow>
                            {showTypeAnalysis && (
                                <PerformanceFilterField>
                                    <InputSelect
                                        size={"small"}
                                        type="text"
                                        name="typeAnalysis"
                                        defaultValue={'TECHNICAL'}
                                        label={t('performance_filter_label_input_type_analysis')}
                                        options={[
                                            {key: 'FUNDAMENTAL', value: 'Fundamentalista'},
                                            {key: 'TECHNICAL', value: 'Técnica'},
                                        ]}
                                    />
                                </PerformanceFilterField>
                            )}
                            <PerformanceFilterField>
                                <InputDate
                                    size={"small"}
                                    name="year"
                                    label={t('year')}
                                    inputFormat={'YYYY'}
                                    views={['year']}
                                    value={new Date()}
                                />
                            </PerformanceFilterField>
                            <PerformanceFilterActions>
                                <CustomButton
                                    className="btn font-weight-bold text-capitalize mobile-button"
                                    type="submit"
                                    style={performancePrimaryButtonStyle}
                                    onMouseEnter={buttonHoverIn}
                                    onMouseLeave={buttonHoverOut}
                                    startIcon={<AiOutlineSearch/>}
                                >
                                    {t('filter_btn_submmit')}
                                </CustomButton>
                            </PerformanceFilterActions>
                        </PerformanceFilterRow>
                    </FormWrapper>
                </Form>
            </PerformanceFilterSection>

            <PerformanceChartHeading>
                <i className="far fa-calendar-alt" aria-hidden="true"/>
                {t('performance_graphic_month_title', {
                    year: filter.year,
                })}
            </PerformanceChartHeading>

            {isData ?
                <>
                    <PerformanceChartWrap>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={options}
                        />
                    </PerformanceChartWrap>
                </> :
                <Alert severity="warning">{messageTypes.REGISTER_NOT_FOUNT}</Alert>
            }
        </div>
    );
}

